export default String.raw`

{% assign wishlist = customer-profile.WishListsProductsPagination -%}

{% if wishlist.TotalItems > 0 -%}
    {% assign showDeposit = false -%}
    {% for item in wishlist.Data -%}
        {% if item.Product.DepositValue > 0 -%}
            {% assign showDeposit = true -%}
        {% endif -%}
    {% endfor -%}
    <div class="eshop__table-container">
        <table>
            <colgroup>
                <col style="width:400px">
                <col style="width:140px">
                <col style="width:140px">
                <col style="width:140px">
            </colgroup>
            <thead>
                <tr>
                    <th class="id">{{ translations.Product }}</th>
                    <th>{{ translations.Com_Quantity }}</th>
                    <th>{{ translations.Price }} {{ whatPrice }}</th>
                    <th>{{ translations.Value }} {{ whatPrice }}</th>
                    {% if showDeposit == true -%}
                        <th>{{ translations.Com_Deposit }}</th>
                    {% endif -%}
                    {% if config.B2B == false -%}
                        <th>
                            {{ translations.ReminderDate }}
                        </th>
                    {% endif -%}
                </tr>
            </thead>
            {% assign index = 1 %}
            {% include 'partials/wishlist/wishlist-table-item.html' for wishlist.Data -%}
{% else -%}
    <div class="no-data">
        {{ translations.NoProductsInWishList }}
    </div>
{% endif -%}
        </table>
    </div>

<script>
    js.updateTotalPriceOnShoppingList();
    js.updateDepositPriceOnShoppingList();
</script>

{% include 'partials/common/pagination.html' -%}
`